import {
  AdminLayout,
  useOpenDashServices,
  useTranslation,
} from "@opendash/core";
import { Route, Routes, useParams } from "@opendash/router";
import { AdminToolbar } from "@opendash/ui";
import React, { useState } from "react";
import { GBFSConnectorList } from "./ConnectorListComponent";

import { Input, Layout, Result } from "antd";

const { Search } = Input;
const { Content, Sider } = Layout;

export const GBFSConnectorOverview = (props) => {
  const t = useTranslation();
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const params = useParams();
  const { SourceService } = useOpenDashServices();
  if (showError) {
    return (
      <Result
        title={t("miaas:overview.error")}
        subTitle={t("miaas:overview.errorSubtitle")}
      ></Result>
    );
  }
  return (
    <AdminLayout>
      <AdminToolbar
        title={t("miaas:overview.label")}
        description={t("miaas:overview.description")}
        search={""}
        actions={[]}
      />
      <div className="od-page-main">
        <Layout style={{ background: "#fff" }}>
          <Layout style={{ backgroundColor: "var(--opendash-color-white)" }}>
            <Content
              className="site-layout-background"
              style={{
                margin: 0,
                minHeight: 280,
              }}
            >
              <Routes>
                <Route path="*" element={<GBFSConnectorList />}>
                  {" "}
                </Route>
              </Routes>
            </Content>
          </Layout>
        </Layout>
      </div>
    </AdminLayout>
  );
};
export default GBFSConnectorOverview;
